export default [{"url":"https://oasis-place-0.api.invexerp.io","name":"Branch 1","port":"5020","isStore":true,"isHQ":true}]